import { type ReactElement } from "react";

import type { QuestionnaireOut, StudyQuestionnaire } from "../../api/types";
import { dueStudyQuestionnaires } from "../../features/dashboard/protocol";
import { TabPanel } from "../Tabs";
import { QuestionnaireForm } from "./QuestionnaireForm";

// Study tasks: the protocol-defined supplemental questionnaires that are due
// (one_time until submitted; daily once per day; day-lists on matching study
// days). Shown as its own tab only when the study configures questionnaires.
export function StudyTasksTab({
  specs,
  responses,
  studyDay,
  onSubmitted,
}: {
  specs: StudyQuestionnaire[];
  responses: QuestionnaireOut[];
  studyDay: number | null;
  onSubmitted: () => Promise<void>;
}): ReactElement {
  const due = dueStudyQuestionnaires(specs, responses, studyDay);
  return (
    <TabPanel id="tasks" title="Study Tasks">
      {due.length === 0 ? (
        <p className="muted">
          Nothing due right now. Thank you! Check back on your next study day.
        </p>
      ) : (
        due.map((spec) => <QuestionnaireForm key={spec.key} spec={spec} onSubmitted={onSubmitted} />)
      )}
    </TabPanel>
  );
}
